import * as React from "react";
import DataGrid from "../../../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Task from "../../../../model/task/Task";
import "./taskTable.scss"
import Toast from "../../../helper/Toast";
import {api} from "../../../../api/api";
import {isDefined} from "../../../../utils/Utils";
import UploadTaskItemsModal from "../../surveyQuestionsTool/modal/UploadTaskItemsModal";
import {none, option, Option} from "ts-option";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";
import Spinner from "../../../../hiberUiKit/src/atoms/Spinner/Spinner";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import TextUtils from "../../../../utils/TextUtils";

const spinner = require("./../../../../../resources/hiber/img/spinner-orange.png");

interface IProps {
	tasks: Task[];
	onRowClick: (task: Task) => void;
	templatesGroupedByTasks: Option<{ [key: string]: DictionaryItem[] }>;
	navigatesToActivityTemplate: (atId: string) => void;
}

interface IState {
	exportLoading: { [key: string]: boolean }
	uploadingTaskId: Option<string>
}

export default class TasksTable extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);

		this.state = {exportLoading: {}, uploadingTaskId: none};
	}

	render() {
		return (
			<DataGrid hasHover hasPointer>
				<thead>
				<tr>
					<th style={{width: "40%"}}>Name</th>
					<th style={{width: "30%"}}>Activity templates</th>
					<th style={{width: "30%"}}>Actions</th>
				</tr>
				</thead>
				<tbody>
				{this.props.tasks
					.map((t, index) =>
						<tr key={index} onClick={() => this.props.onRowClick(t)}>
							<td>{t.title}</td>
							<td className={"c-task-table_activity-templates"}>
								{this.renderActivityTemplates(t)}
							</td>
							<td className={"c-task-table_buttons"}>
								<ButtonPrimary label={"Import"}
											   onClick={() => this.setState({uploadingTaskId: option(t.id)})}/>
								<ButtonPrimary label={"Export"} disabled={isDefined(this.state.exportLoading[t.id])}
											   onClick={() => this.downloadTaskItems(t)}/>
							</td>
						</tr>
					)
				}
				</tbody>
				{this.state.uploadingTaskId.map(tId => {
					return (
						<UploadTaskItemsModal taskId={tId}
											  onSuccess={() => this.setState({uploadingTaskId: none})}
											  onCancel={() => this.setState({uploadingTaskId: none})}/>
					)
				}).orNull}
			</DataGrid>
		)
	}

	renderActivityTemplates(task: Task) {
		return (
			this.props.templatesGroupedByTasks.map(tgbt =>
				<React.Fragment>
					{isDefined(tgbt[task.id]) && tgbt[task.id]
						.map((at, index) => <ButtonTertiary key={index}
															label={TextUtils.textEllipsis(at.name)}
															onClick={() => this.props.navigatesToActivityTemplate(at.id)}/>
						)}
				</React.Fragment>
			).getOrElse(<Spinner imgUrl={spinner} isCentered={false}/>)
		)
	}

	downloadTaskItems(task: Task) {
		const loadingState = this.state.exportLoading;
		loadingState[task.id] = true;
		this.setState({exportLoading: loadingState}, () => api.instance.taskApi.downloadTaskItems(task.id)
			.then(() => this.stopExportLoading(task))
			.catch(() => {
				this.stopExportLoading(task);
				Toast.error("Sorry, something went wrong. Try again later.", "Download task items");
			}));
	}

	stopExportLoading(task: Task) {
		const loadingState = this.state.exportLoading;
		delete loadingState[task.id];
		this.setState({exportLoading: loadingState});
	}
}